import {User} from "~/models/auth";
import {useCustomerService} from "~/services/customerService";
import {useContractService} from "~/services/contractService";
import {useEntrepreneurService} from "~/services/entrepreneurService";
import {useQuestionService} from "~/services/questionService";
import {useAssortmentService} from "~/services/assortmentService";
import {useManagerService} from "~/services/managerService";
import {usePlantingStandardService} from "~/services/plantingStandardService";
import {useProductService} from "~/services/productService";
import {useAllmaService} from "~/services/allmaService";
import {useReallocatedAreasService} from "~/services/reallocatedAreasService";
import {usePriceListService} from "~/services/priceListService";
import {useTransportService} from "~/services/transportService";
import {useTrackDamageService} from "~/services/trackDamageService";
import {useProjectService} from "~/services/projectService";

export const getAlwaysAvailableQueryOptions = (currentUser: Ref<User | undefined>) => {
    const { getCustomersQueryOptions } = useCustomerService()
    const { getContractListQueryOptions } = useContractService()
    const { entrepreneursQueryOptions } = useEntrepreneurService()
    const { getQuestionDefinitionsQueryOptions, getQuestionTemplatesQueryOptions } = useQuestionService()
    const { getAssortmentsQueryOptions } = useAssortmentService()
    const { managersQueryOptions } = useManagerService()
    const { plantingStandardQueryOptions } = usePlantingStandardService()
    const { productQueryOptions } = useProductService()
    const { getThematicMapTypesQueryOptions } = useAllmaService()
    const { reallocatedAreasQueryOptions } = useReallocatedAreasService()
    const { priceListsQueryOptions, priceListAreasQueryOptions, priceTypesQueryOptions } = usePriceListService()
    const thematicMapTypesQueryOptions = getThematicMapTypesQueryOptions()
    const { parkedTransportOrdersQueryOptions, parkedTransportShipmentDetailsByVsysIdQueryOptions } = useTransportService()
    const { getOperationsWithTrackDamageQueryOptions } = useTrackDamageService()
    const { nonInvoicedOrdersQueryOptions } = useProjectService()

    return [
        getCustomersQueryOptions,
        getContractListQueryOptions,
        entrepreneursQueryOptions,
        thematicMapTypesQueryOptions,
        getQuestionDefinitionsQueryOptions,
        getQuestionTemplatesQueryOptions,
        getAssortmentsQueryOptions,
        managersQueryOptions,
        plantingStandardQueryOptions,
        productQueryOptions,
        priceListsQueryOptions,
        priceListAreasQueryOptions,
        priceTypesQueryOptions,
        reallocatedAreasQueryOptions,
        parkedTransportOrdersQueryOptions,
        parkedTransportShipmentDetailsByVsysIdQueryOptions,
        getOperationsWithTrackDamageQueryOptions(currentUser),
        nonInvoicedOrdersQueryOptions,
    ]
}